import { Injectable } from '@angular/core';
import { ExporterQaParserService } from './history/qa.service';
import { ExporterSeoParserService } from './history/seo.service';
import { ExporterPolicyParserService } from './history/policy.service';
import { ExporterAccessibilityParserService } from './history/accessibility.service';
import { ExporterReadabilityParserService } from './history/readability.service';
import { ExporterDataPrivacyParserService } from './history/data-privacy.service';
import { ExporterPerformanceParserService } from './history/performance.service';
import { ExporterAllParserService } from './history/all.service';
import { ExporterAuditLogParserService } from './audit-log/audit-log.service';
import { PerformanceAuditsDetailsParser } from '@client/app/modules/export/services/performance/performance-audits-details.service';
import { CsvExportAuditLogDialogComponent } from '../components/dialog/dialog-auditlog.component';
import { MonEventService } from '@monsido/ng2/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/ng2/core/constants/mon-events.constant';
import { DialogService } from '@monsido/angular-shared-components';
import { PerformanceAuditsParserService } from '@client/app/modules/export/services/performance/performance.service';

@Injectable({
    providedIn: 'root',
})
export class ExporterService {
    constructor (
        private readonly qaService: ExporterQaParserService,
        private readonly seoService: ExporterSeoParserService,
        private readonly policyService: ExporterPolicyParserService,
        private readonly accessibilityService: ExporterAccessibilityParserService,
        private readonly readabilityService: ExporterReadabilityParserService,
        private readonly dataPrivacyService: ExporterDataPrivacyParserService,
        private readonly performanceService: ExporterPerformanceParserService,
        private readonly allService: ExporterAllParserService,
        private readonly auditLogService: ExporterAuditLogParserService,
        private readonly performanceAuditsDetailsService: PerformanceAuditsDetailsParser,
        private readonly eventService: MonEventService,
        private readonly dialogService: DialogService,
        private readonly performanceAuditsParserService: PerformanceAuditsParserService,
    ) {
    }

    connectedModules: { [key: string]: any } = {};

    parseHistory (module: string, data: any[]): any[] {
        switch (module) {
            case 'qa':
                return this.qaService.parse(data);
            case 'seo':
                return this.seoService.parse(data);
            case 'policy':
                return this.policyService.parse(data);
            case 'accessibility':
                return this.accessibilityService.parse(data);
            case 'readability':
                return this.readabilityService.parse(data);
            case 'data-privacy':
                return this.dataPrivacyService.parse(data);
            case 'performance':
                return this.performanceService.parse(data);
            case 'all':
                return this.allService.parse(data);
            default:
                return [];
        }
    }

    async parseAuditLog (params: any, options: any): Promise<any[]> {
        const dialogParams = {
            component: CsvExportAuditLogDialogComponent,
            dialogOptions: {
                size: 'sm',
                classes: 'fade-animation middle center mon-dialog',
            },
        };
        await this.eventService.run(MON_EVENTS.LOAD_NG2_DIALOG, dialogParams);
        this.auditLogService.setGetAuditLogsProgress(0, options.total);
        return this.auditLogService.getData(params, []).finally(() => {
            this.auditLogService.clearGetAuditLogsProgress();
            this.dialogService.closeAll();
        });
    }

    cancelAuditLog (): void {
        this.auditLogService.stopGetData();
    }

    parsePerformanceAudits (data) {
        //             return ng2PerformanceAuditsParserService.parse(data);
        return this.performanceAuditsParserService.parse(data);
    }

    parsePerformanceAuditsDetails (data) {
        return this.performanceAuditsDetailsService.parse(data);
    }

    connectToCSVExporter (moduleName, callbackReturningExportData) {
        this.connectedModules[moduleName] = callbackReturningExportData;
    }

    disconnectFromCSVExporter (moduleName) {
        delete this.connectedModules[moduleName];
    }

    requestExportFromModule (moduleName) {
        const callbackReturningExportData = this.connectedModules[moduleName];

        if (typeof callbackReturningExportData === 'function') {
            return this.parseHistory(moduleName, callbackReturningExportData());
        }
        return undefined;
    }
}
